import React from 'react';
import { Grid } from '@mui/material';
import Loading from 'components/Messages/Loading/Loading';
import Error from 'components/Messages/Error/Error';
import TenantsTable from './Table/Table';
import { TenantsContextProvider, useTenantsContext } from './tenants.context';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import CreateTenant from './CreateTenant';
import ContentWrapper from 'components/StyledComponents/ContentWrapper';

const TenantsComponent = (): JSX.Element => {
  const { loading, createTenantLoading, error } = useTenantsContext();

  if (loading) {
    return <Loading />;
  }

  // creating a tenant takes time to go through aws
  if (createTenantLoading) {
    return <Loading message='Configuring new tenant...' />;
  }

  if (error) {
    return <Error message='There was an error loading Tenants' />;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <SectionHeader title='Tenants' actions={<CreateTenant />} pageHeader />
        <ContentWrapper>
          <TenantsTable />
        </ContentWrapper>
      </Grid>
    </Grid>
  );
};

// wrapping component in context provider for full access
const Tenants = () => (
  <TenantsContextProvider>
    <TenantsComponent />
  </TenantsContextProvider>
);

export default Tenants;
